import FuturesContract from "domain/futuresContract";
import futuresContractsService from "./futuresContracts.service";
import Event from "common/event";
import FuturesPriceUpdate from "./futuresPriceUpdate";
import { Dispatch } from "redux";

export class FuturesContractPriceUpdated extends Event {
    constructor(public contract: FuturesPriceUpdate) {
        super(FuturesContractPriceUpdated.EventName);
    }

    public static EventName: string = "FUTURES_CONTRACT_PRICE_UPDATED";
}

export class ContractsSubscribed extends Event {
    constructor(public subscriptionId: string, public symbols: string[]) {
        super(ContractsSubscribed.EventName);
    }

    public static EventName: string = "CONTRACTS_SUBSCRIBED";
}

export class ContractsUnsubscribed extends Event {
    constructor(public subscriptionId: string) {
        super(ContractsUnsubscribed.EventName);
    }

    public static EventName: string = "CONTRACTS_UNSUBSCRIBED";
}

export function subscribeToContracts(subscriptionId: string, symbols: string[]) {
    return (dispatch: Dispatch) => dispatch(new ContractsSubscribed(subscriptionId, symbols).toObject());
}

export function unsubscribeFromContracts(subscriptionId: string) {
    return function (dispatch: Dispatch) {
        dispatch(new ContractsUnsubscribed(subscriptionId).toObject());
    };
}

export function requestSnapshotQuote(dispatch: Dispatch, futuresContract: FuturesContract) {
    futuresContractsService.getRealTimeSnapshot(futuresContract.id)
        .then(m => dispatch(new FuturesContractPriceUpdated(m).toObject()))
}

